import { Component, h, Host, Prop, Watch } from '@stencil/core';

@Component({
  tag: 'ui-cms-footer',
  styleUrl: 'ui-cms-footer.scss',
  shadow: false,
})
export class UiCmsFooter {
  @Prop({ mutable: true }) i18n = { footerDescription: 'Weitere Seiteninformationen' };

  @Prop({ attribute: 'i18n' }) utilityI18n: string;

  @Watch('utilityI18n')
  utilityI18nChangeHandler(newValue: string) {
    if (newValue) this.i18n = { ...this.i18n, ...JSON.parse(newValue) };
  }

  render() {
    return (
      <Host tabindex="0">
        <h2 class="sr-only">{this.i18n.footerDescription}</h2>
        <ui-container variant="secondary100" full-width>
          <footer id="cms-footer">
            <slot></slot>
          </footer>
        </ui-container>
      </Host>
    );
  }
}
